import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import Duration from "./images/duration.png";

const PopularSectors = ({ data }) => {
  const [showIcon, setShowIcon] = useState(false);

  const colors = [
    "#4285F4",
    "#00C49F",
    "#FFBB28",
    "#eb3f79",
    "#294170",
    "#11777a",
    "#ff9d9d",
    "#8884d8",
  ];
  const chartData = data.map((item, index) => ({
    name: item.domain,
    value: item.count,
    color: colors[index % colors.length],
  }));
  useEffect(() => {
    const storedStart = localStorage.getItem("startDate");
    const storedEnd = localStorage.getItem("endDate");

    if (!storedStart || !storedEnd) {
      setShowIcon(false);
      return;
    }

    const startDate = new Date(storedStart);
    const endDate = new Date(storedEnd);

    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    const isDefaultStart =
      startDate.getFullYear() === firstDayOfMonth.getFullYear() &&
      startDate.getMonth() === firstDayOfMonth.getMonth() &&
      startDate.getDate() === firstDayOfMonth.getDate();

    const isDefaultEnd =
      endDate.getFullYear() === today.getFullYear() &&
      endDate.getMonth() === today.getMonth() &&
      endDate.getDate() === today.getDate();

    setShowIcon(!(isDefaultStart && isDefaultEnd));
  }, []);

  return (
    <div className="user-statistics">
      {showIcon && (
        <img src={Duration} alt="duration" className="duration-icon" />
      )}
      <h3>Popular Sectors</h3>
      {data && data.length > 0 ? (
        <div className="user-stats-content">
          <div className="donut-chart">
            <PieChart width={200} height={200}>
              <Pie
                data={chartData}
                dataKey="value"
                innerRadius={60}
                outerRadius={80}
                paddingAngle={3}
              >
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip
                formatter={(value, name) => {
                  const total = chartData.reduce(
                    (acc, cur) => acc + cur.value,
                    0
                  );
                  const percent = ((value / total) * 100).toFixed(1);
                  return [`${percent}%`, name];
                }}
              />
            </PieChart>
            <div className="legend">
              {chartData.map((entry, index) => (
                <div key={index} className="legend-item">
                  <span
                    className="legend-color"
                    style={{ backgroundColor: entry.color }}
                  ></span>
                  <span className="legend-label">{entry.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <p className="no-data-message">No data available</p>
      )}
    </div>
  );
};

export default PopularSectors;
